/* eslint-disable max-len */
import React, { Fragment } from 'react'
import TableBody from './TableBody'
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import { useState,useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { selectAllRows } from '../../../../redux/MultiselectRows';
import { useSelector ,useDispatch} from 'react-redux';
import SearchEmptyScreen from '../../../../components/SearchEmptyScreen';

const Table=({pageNumber,List,handleSearchParams,sortValue,setisSortSelected,setConfirmationState,setTextAreaMsg})=>{
    const [searchParams,setSearchParams]=useSearchParams()
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const selectedRows=useSelector((state)=>state?.MultiSelectSlice?.selectedRows?.topCheckBox)
    const urlParams = new URLSearchParams(window.location.search);
    const branchUrl = urlParams.get('sort');
    const dispatch=useDispatch()
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });

    const handleAllRowsSelect=(event)=>{
        const paramstoPass=[event.target.checked,pageNumber.toString(),List.data]
        dispatch(selectAllRows(paramstoPass))   
    }

    const handleSort = (key) => {
        setisSortSelected(true)
        if(sortValue === '') handleSearchParams('sort', `${key}+asc`)
        else {
            if(sortValue.includes(key)) handleSearchParams('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleSearchParams('sort', `${key}+asc`)
        }
    }

    return(
        <div>
            <div className='h-[calc(100vh-218px)] overflow-auto scrollbar_purple pb-2.5'>
                <table aria-label="Outside Table" className="w-full table-auto">
                    <thead>
                        <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-0 left-0 z-[1]">
                            <th id="id" className="px-3 py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm" onClick={() => {handleSort('organization_id')}}>
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">ID
                                    <button  className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "organization_id" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                                </span>
                            </th>
                            <th id="oganization_name" className="px-3 py-2 min-w-[200px] rounded-tl-sm rounded-bl-sm" onClick={() => {handleSort('organization_name')}}>
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Organization Name
                                    <button  className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "organization_name" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                                </span>
                            </th>
                            <th id="main_number" className="px-3 py-2 min-w-[180px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Main Number
                                </span>
                            </th>
                            <th id='value_added' className="px-3 py-2 min-w-[140px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Value Added
                                </span>
                            </th>
                            <th id="direct_billing" className="px-3 py-2 min-w-[140px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Direct Billing
                                </span>
                            </th>
                            <th id="create_date" className="px-3 py-2 min-w-[200px] rounded-tl-sm rounded-bl-sm"  onClick={() => {handleSort('created_at')}}>
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Created Date
                                    <button className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "created_at" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                                </span>
                            </th>
                            <th className="px-3 py-2 rounded-tr-[2px] rounded-br-[2px] sticky top-0 right-[-1px] bg-[#EDD7E1] min-w-[70px]">
                                <span className="flex items-center justify-center text-sm font-normal text-[#000000]">Actions
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {List?.data?.map((item,index)=>(
                            <Fragment key={index}>
                                <TableBody
                                    tableData={item}
                                    List={List}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List?.data?.length}
                                    setConfirmationState={setConfirmationState}
                                    setTextAreaMsg={setTextAreaMsg}
                                />
                            </Fragment>
                        ))}
                        
        
                    </tbody>
                    
                </table>

            </div>
        </div>
    )
}

export default Table